import React from "react";
import { Modal, ModalHeader, ModalFooter, ModalBody, ModalContent, ModalOverlay, Flex, Button } from "@govlaunch/web";
import { FormattedMessage } from "react-intl";

interface IPreviewModalProps {
  isOpen: boolean;
  onClose: () => any;
  header: string;
  text: string;
  onPreviewBasicClick: () => any;
  onPreviewMakersClick: () => any;
}

export default function PreviewModal({
  isOpen,
  onClose,
  header,
  text,
  onPreviewBasicClick,
  onPreviewMakersClick,
}: IPreviewModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnEsc={false} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center">{header}</ModalHeader>
        <ModalBody textAlign="center">{text}</ModalBody>

        <ModalFooter justifyContent="center">
          <Flex direction="row" justifyContent="space-between">
            <Button variantColor="blue" onClick={onPreviewBasicClick}>
              <FormattedMessage defaultMessage="Continue as Basic" id="PdBd+0" />
            </Button>
            <Button variantColor="teal" ml={2} onClick={onPreviewMakersClick}>
              <FormattedMessage defaultMessage="Preview as Makers" id="qbrGOa" />
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
